import { stripHtml } from "./slug";

export function cleanTourTitle(title: string): string {
  return title.trim().replace(/\s+/g, " ").replace(/\s+([,.;:!?])/g, "$1");
}

export function metaDescription(text: string, max = 155): string {
  const clean = stripHtml(text).replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const prefix = clean.slice(0, max);
  const sentence = [...prefix.matchAll(/[.!?](?=\s|$)/g)].at(-1);
  if (sentence?.index != null) return prefix.slice(0, sentence.index + 1);
  const words = clean.slice(0, max - 1).replace(/\s+\S*$/, "").trim().replace(/[,;:]$/, "");
  return words ? `${words}…` : "";
}

export function withoutRepeatedSummary(description: string, summary: string): string {
  const desc = description.trim();
  const short = summary.trim();
  if (!short) return desc;
  return desc.startsWith(short) ? desc.slice(short.length).trim() : desc;
}

export type VerifiedDisplayPrice = { amount: number; currency: string; unit?: "adult" | "vehicle" };
export function validCachedFinalPrice(value: unknown): VerifiedDisplayPrice | null {
  if (!value || typeof value !== "object") return null;
  const p = value as Record<string, unknown>;
  if (typeof p.amount !== "number" || !Number.isFinite(p.amount) || p.amount <= 0 || p.currency !== "MXN") return null;
  if (p.unit != null && p.unit !== "adult" && p.unit !== "vehicle") return null;
  return { amount: p.amount, currency: p.currency, ...(p.unit ? { unit: p.unit as "adult" | "vehicle" } : {}) };
}